import React from 'react'
import { AlertIcon, Button, colors, DialogActions, DialogContent, DialogTitle } from '@diversioteam/diversio-ds'

import { DeleteSurveyDialogProps } from './deleteSurveyDialog.types'
import * as S from './deleteSurveyDialog.styles'

export const DeleteSurveyDialog = ({ open, surveyTitle, onClose, onConfirm }: DeleteSurveyDialogProps) => {
    return (
        <S.Dialog open={open} onClose={onClose} hideBackdrop={false}>
            <DialogTitle>
                <S.IconWrapper>
                    <AlertIcon type="bold" color={colors.primaryWhite} />
                </S.IconWrapper>
                Remove {surveyTitle}?
            </DialogTitle>

            <DialogContent>
                This action is permanent and cannot be undone. Please confirm before continuing.{' '}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondaryLight" fullWidth>
                    Cancel
                </Button>

                <Button onClick={onConfirm} color="primary" fullWidth>
                    Delete
                </Button>
            </DialogActions>
        </S.Dialog>
    )
}
